import React, { FC } from 'react'
import { cn } from 'shared/utils'
import { Button } from '@wmgtech/legato'

import { StoryToggleProps } from './StoryToggle.props'

const StoryToggle: FC<StoryToggleProps> = ({ isCollapsed, toggleCollapsedHandler, dataTestPrefix }) => (
  <div className={cn('story-article-toggle', { 'story-article-toggle--collapsed': isCollapsed })}>
    <Button
      data-test={`${dataTestPrefix}_${isCollapsed ? 'expand' : 'collapse'}`}
      secondaryIcon={`circle-arrow-${isCollapsed ? 'down' : 'up'}`}
      className="story-article-toggle__button"
      onClick={toggleCollapsedHandler}
      colorType="secondary-black"
      size="sm"
    >
      {isCollapsed ? 'Expand' : 'Collapse'} Story
    </Button>
  </div>
)

export default StoryToggle
